import { useEffect } from 'react'
import { useAuth } from 'react-oidc-context'

export function TokenSync() {
  const auth = useAuth()

  useEffect(() => {
    if (!auth.isAuthenticated || !auth.user?.access_token) {
      return
    }

    const keycloakToken = auth.user.access_token
    const expiresIn = auth.user.expires_in ?? 3600

    localStorage.setItem('auth_token', keycloakToken)
    const expiryTime = Date.now() + expiresIn * 1000
    localStorage.setItem('auth_token_expiry', expiryTime.toString())
  }, [auth.isAuthenticated, auth.user?.access_token, auth.user?.expires_in])

  return null
}
